/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'n_flag': {
    width: 14,
    height: 15,
    viewBox: '0 0 14 15',
    data: '<path d="M3.00415 1.66797V13.3346" stroke="#FF2360" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.00415 2.83203H9.53748C11.1125 2.83203 11.4625 3.70703 10.3542 4.81536L9.65415 5.51536C9.18748 5.98203 9.18748 6.74036 9.65415 7.1487L10.3542 7.8487C11.4625 8.95703 11.0542 9.83203 9.53748 9.83203H3.00415" stroke="#FF2360" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})